<template>
  <div :class="[iphoneX?'iphoneX':'goldFree']">
    <c-nav></c-nav>
    <div class="container">
      <div class="rule" @click="gotoRule">活动规则</div>
      <div class="congratulation">
        <div>恭喜 <span class="white">{{userTel}}</span> 用户</div>
        <div>成功免费领取1个月黄金会员权益</div>
        <div class="more">请前往高铁管家客户端了解更多会员权益</div>
      </div>
      <div class="priority">
        <div class="title">五大会员专属特权</div>
        <div class="content">
          <div class="birthday fx fx-c-center">
            <div class="icon"></div>
            <div class="desc"><span class="red">29元</span>生日礼物</div>
          </div>
          <div class="hotel fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">酒店专享<span class="red">9.4折</span></div>
          </div>
          <div class="speedup fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">抢票提速<span class="red">1.5倍</span></div>
          </div>
          <div class="tisubao fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">提速宝<span class="red">10个</span></div>
          </div>
          <div class="delayTreture fx fx-c-center">
            <div class="icon"></div>
            <div class="desc">延误宝<span class="red">2个</span></div>
          </div>
        </div>
      </div>
    </div>
    <rule :isShowRule='isShowRule' @close='close'></rule>
    <bottom-button text='查看我的会员权益' @gotoDownload='gotoDownload'></bottom-button>
  </div>
</template>
<script>
  import bottomButton from './components/bottomButton'
  import rule from './components/rule.vue'
  import localStorage from "@/utils/localStorage.js";
  import downloadApp from '../../Helper/download-app.js';

  export default {
    data() {
      return {
        iphoneX: false,
        isShowRule:false
      }
    },
    created() {
      this.iphoneX = this.isIphoneX();
    },
    mounted() {
      this.$updateTitle('会员新福利');
    },
    computed: {
      userTel() {
        let phone = '';
        let user = localStorage.get("user");
        phone = user.phone;
        phone = phone.split('');
        phone = phone.map((element, index) => {
          if (index >= 3 && index <= 6) {
            return '*';
          } else {
            return element;
          }
        })
        phone = phone.join('');
        return phone;
      }
    },
    methods: {
      gotoRule() {
        this.isShowRule = true;
      },
      close () {
        this.isShowRule = false;
      },
      isIphoneX() {
        return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
      },
      gotoDownload() {
        downloadApp();
      }
    },
    components: {
      bottomButton,
      rule
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/scss/_vars.scss';
  @import './style/common.scss';
  .red {
    color: #f43b41;
  }
  .white {
    color: #fff;
  }
  .goldFree,
  .iphoneX {
    width: 100%;
    height: 100%;

    .container {
      width: 100%;
      height: 603*$px;
      overflow: hidden;
      position: relative;
      @include bg('bg2-fix@3x.png');
      .rule {
        position: absolute;
        right: 0;
        top: 16*$px;
        width: 65*$px;
        background-color: rgba(0, 73, 219, 0.3);
        color: rgba(255, 255, 255, 0.68);
        text-align: center;
        font-size: 12*$px;
        height: 21*$px;
        line-height: 21*$px;
        border-top-left-radius: 10*$px;
        border-bottom-left-radius: 10*$px;
      }
      .congratulation {
        margin-top: 140*$px;
        height: 105*$px;
        font-size: 14*$px;
        text-align: center;
        color: #eedc9c;
        >div {
          margin-bottom: 7*$px;
        }
        .more {
          font-size: 12*$px;
          color: rgba(256, 256, 256, 0.6)
        }
      }
      .priority {
        box-sizing: border-box;
        position: absolute;
        left: 118*$px;
        top: 253*$px;
        height: 345*$px;
        width: 202*$px;
        .title {
          height: 56*$px;
          line-height: 56*$px;
          font-size: 17*$px;
          margin-top: 13*$px;
          text-align: center;
          color: #fff;
          position: relative;
          &::before {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            left: 12*$px;
            top: 20*$px;
          }
          &::after {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            right: 12*$px;
            top: 20*$px;
          }
        }
        .content {
          height: 250*$px;
          padding-left: 32*$px;
          padding-top: 19*$px;
          .birthday,
          .hotel,
          .speedup,
          .tisubao,
          .delayTreture {
            font-size: 13*$px;
            margin-bottom: 7*$px;
            .icon {
              width: 30*$px;
              height: 30*$px;
              margin-right: 16*$px;
              @include bg('1@3x.png');
            }
            .desc {
              margin-top: 2*$px;
            }
          }
          .hotel {
            .icon {
              @include bg('2@3x.png')
            }
          }
          .speedup {
            .icon {
              @include bg('3@3x.png')
            }
          }
          .tisubao {
            .icon {
              @include bg('4@3x.png')
            }
          }
          .delayTreture {
            .icon {
              @include bg('5@3x.png')
            }
          }
        }
      }
    }
  }
  .iphoneX {
    width: 100%;
    height: 768*$px;
    background-color: #161439;

    .container {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      @include bg('bg2_iphonex@3x.png');
      .rule {
        position: absolute;
        right: 0;
        top: 16*$px;
        width: 65*$px;
        background-color: rgba(0, 73, 219, 0.3);
        color: rgba(255, 255, 255, 0.68);
        text-align: center;
        font-size: 12*$px;
        height: 21*$px;
        line-height: 21*$px;
        border-top-left-radius: 10*$px;
        border-bottom-left-radius: 10*$px;
      }
      .congratulation {
        margin-top: 173*$px;
        height: 105*$px;
        font-size: 14*$px;
        text-align: center;
        color: #eedc9c;
        >div {
          margin-bottom: 7*$px;
        }
        .more {
          font-size: 12*$px;
          color: rgba(256, 256, 256, 0.6)
        }
      }
      .priority {
        box-sizing: border-box;
        position: absolute;
        left: 118*$px;
        top: 323*$px;
        height: 345*$px;
        width: 202*$px;
        .title {
          height: 76*$px;
          line-height: 56*$px;
          font-size: 17*$px;
          margin-top: 13*$px;
          text-align: center;
          color: #fff;
          position: relative;
          &::before {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            left: 12*$px;
            top: 20*$px;
          }
          &::after {
            display: block;
            height: 12*$px;
            width: 12*$px;
            content: '';
            @include bg('star@3x.png');
            position: absolute;
            right: 12*$px;
            top: 20*$px;
          }
        }
        .content {
          height: 250*$px;
          padding-left: 32*$px;
          padding-top: 19*$px;
          .birthday,
          .hotel,
          .speedup,
          .tisubao,
          .delayTreture {
            font-size: 13*$px;
            margin-bottom: 12*$px;
            .icon {
              width: 30*$px;
              height: 30*$px;
              margin-right: 16*$px;
              @include bg('1@3x.png');
            }
            .desc {
              margin-top: 2*$px;
            }
          }
          .hotel {
            .icon {
              @include bg('2@3x.png')
            }
          }
          .speedup {
            .icon {
              @include bg('3@3x.png')
            }
          }
          .tisubao {
            .icon {
              @include bg('4@3x.png')
            }
          }
          .delayTreture {
            .icon {
              @include bg('5@3x.png')
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldFree/vipPriority.vue